<template>
  <h2
    style="text-align: center"
    v-if="getAllProjects.some((x) => !x.HasAccess && x.IsPurchasable)"
    class="mt-5"
  >
    Get More Evo Apps!
  </h2>
  <div
    v-if="getAllProjects.some((x) => !x.HasAccess && x.IsPurchasable)"
    class="container-fluid w-50"
    style="filter: grayscale(1)"
  >
    <div class="row">
      <div
        v-for="resource in getAllProjects.filter(
          (x) => !x.HasAccess && x.IsPurchasable
        )"
        class="col-md-6 mt-4"
        v-bind:key="resource"
      >
        <default-info-card
          :classIcon="resource.IconClass"
          :title="resource.Title"
          :to="resource.Link"
          :showButton="false"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {DefaultInfoCard }from "@/components/exporter.js";
import { mapGetters } from "vuex";

export default {
  name: "dashboard-default",
  components: {
    DefaultInfoCard,
  },
  computed: mapGetters(["getAllProjects", "getIsLogined"]),
};
</script>
